import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { IKeg, IKegVM } from 'app/models/keg';
import { ILocation } from 'app/models/location';
import * as dateHelper from 'app/helpers/date.helpers';
import { KegSvgComponent } from 'app/pages/home/taps/keg-svg/keg-svg.component';

import { CornyKegSvgComponent } from 'app/pages/home/taps/cornykeg-svg/cornykeg-svg.component';
import { CornyKeg09SvgComponent } from 'app/pages/home/taps/cornykeg09-svg/cornykeg09-svg.component';
import { CornyKeg12SvgComponent } from 'app/pages/home/taps/cornykeg12-svg/cornykeg12-svg.component';


@Component({
  selector: 'app-add-keg',
  templateUrl: './add-keg.component.html',
  styleUrls: ['./add-keg.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    KegSvgComponent,
    CornyKegSvgComponent,
    CornyKeg09SvgComponent,
    CornyKeg12SvgComponent
]
})
export class AddKegComponent implements OnInit {

  @Input() keg!: IKegVM | null;
  @Input() allKegs!: IKegVM[];
  @Input() attachedKegs!: IKegVM[];
  @Input() locations!: ILocation[];

  kegs: IKegVM[] = [];
  selectedKeg!: IKegVM;
  form!: FormGroup;

  tapDate?: string | null;
  bestBeforeDate?: string | null;
  notificationDate?: string | null;

  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    // private dateHelper: DateHelper,
  ) {
    this.form = new FormGroup({
      location: new FormControl(''),
      notificationMessage: new FormControl(''),
    });

  }


  ngOnInit(): void {
    if (this.keg) {
      this.patchForm();
      this.bestBeforeDate = dateHelper.getISOString(this.keg.bestBeforeDate as any);
      this.tapDate = dateHelper.getISOString(this.keg.tapDate as any);
      this.notificationDate = dateHelper.getISOString(this.keg.notificationDate as any);
    }

    if (this.allKegs) {
      if (this.attachedKegs) {
        this.kegs = this.allKegs.filter(item1 =>
          !this.attachedKegs.find(item2 => item1.id === item2.id)
        );
        return;
      }
      this.kegs = [...this.allKegs];
    }

  }


  ngOnDestroy() {

  }

  updateNotification() {
    if (!this.keg) {
      return;
    }
    this.keg.notificationMessage = this.form.controls['notificationMessage'].value ?? '';
  }


  private patchForm() {
    this.form.patchValue({
      location: this.keg?.locationId,
      notificationMessage: this.keg?.notificationMessage
    });
  }


  private async confirmUseKeg(keg: IKegVM) {
    if (keg.beverage?.name) {
      const alert = await this.alertController.create({
        header: "Replace keg",
        message: `"${keg.name}" contains "${keg.beverage?.name}". Are you sure you want to use this keg?`,
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: 'alert-button-cancel',
            handler: () => {
              this.keg = null;
            },
          },
          {
            text: "Replace",
            cssClass: 'alert-button-confirm',
            handler: () => {
              this.keg = JSON.parse(JSON.stringify(keg));
              if (this.keg) {
                this.keg.bestBeforeDate = null;
                this.keg.tapDate = null;
                this.keg.notificationDate = null;
                this.keg.locationId = null;
              }
            },

          },
        ],
      });

      await alert.present();
      return;
    }

    this.keg = keg;
  }

  selectKeg(keg: IKeg) {
    if (keg.beverageId) {
      this.confirmUseKeg(keg);
    } else {
      this.keg = JSON.parse(JSON.stringify(keg));
      if (this.keg) {
        this.keg.bestBeforeDate = null;
        this.keg.tapDate = null;
        this.keg.notificationDate = null;
        this.keg.locationId = null;
      }
    }
  }


  updateLocation(event: any) {

    const locationId = event.detail.value;
    if (locationId && this.keg) {
      this.keg.locationId = locationId;
    } else if (this.keg) {
      this.keg.locationId = null;
    }

  }



  closeModal() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  dismiss(item: IKeg) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    item = {
      ...item,
      cleanDate: item.cleanDate ? item.cleanDate : null,
      tapDate: item.tapDate ? item.tapDate : null,
      bestBeforeDate: item.bestBeforeDate ? item.bestBeforeDate : null,
      notificationDate: item.notificationDate ? item.notificationDate : null,
      notificationMessage: item.notificationMessage ? item.notificationMessage : null,
      conditionDate: item.conditionDate ? item.conditionDate : null,
      locationId: item.locationId ? item.locationId : null

    };
    this.modalController.dismiss({
      item
    });
  }

  selected(event: any) {
    if (event.detail.value) {
      this.keg = event.detail.value;
    }
  }


  //#region Date Functions
  //#region BottleDate
  setDefaultKegTapDate() {
    const date = new Date();
    this.tapDate = dateHelper.toISOString();
    if (this.keg)
      this.keg.tapDate = date;
    //this.dismiss(this.item);
  }
  setKegTapDate(event: any) {
    const value = event.detail.value;
    if (value && this.keg) {
      this.keg.tapDate = value;
      //this.dismiss(this.item);
    }
  }
  deleteKegTapDate() {
    if (this.keg)
      this.keg.tapDate = null;
    this.tapDate = null;
    //this.dismiss(this.item);
  }
  //#region BottleDate

  //#region Best Before Date
  setDefaultKegBestBeforeDate() {
    const date = new Date();
    this.bestBeforeDate = dateHelper.toISOString();
    if (this.keg)
      this.keg.bestBeforeDate = date;
    //this.dismiss(this.item);
  }
  setKegBestBeforeDate(event: any) {
    const value = event.detail.value;
    if (value && this.keg) {
      this.keg.bestBeforeDate = value;
      //this.dismiss(this.item);
    }
  }
  deleteKegBestBeforeDate() {
    if (this.keg)
      this.keg.bestBeforeDate = null;
    this.bestBeforeDate = null;
    //this.dismiss(this.item);
  }
  //#region Best Before Date

  //#region Notification Date
  setDefaultKegNotificationDate() {
    const date = new Date();
    this.notificationDate = dateHelper.toISOString();
    if (this.keg)
      this.keg.notificationDate = date;
    //this.dismiss(this.item);
  }
  setKegNotificationDate(event: any) {
    const value = event.detail.value;
    if (value && this.keg) {
      this.keg.notificationDate = value;
      //this.dismiss(this.item);
    }
  }
  deleteKegNotificationDate() {
    if (this.keg)
      this.keg.notificationDate = null;
    this.notificationDate = null;
    //this.dismiss(this.item);
  }
  //#region Notification Date
  //#endregion Date Functons







}
